<div id="actionButtonsContainer" class="flexRowContainer">
  <button mat-icon-button (click)="backToCase()"
          aria-label="Back to case">
    <mat-icon class="material-symbols-outlined">arrow_back</mat-icon>
  </button>
</div>
<div id="startOnlineIdentificationContainer" class="flexColumnContainer">
  <p class="headline-small">{{ 'onlineIdentification.title' | translate }}</p>
  <span id="onlineIdentificationCaseName" class="body-medium">
    {{ 'onlineIdentification.case' | translate }}: {{ case.name }}
  </span>
  <div class="flexRowContainer inputContainer">
    <mat-expansion-panel class="flexColumnContainer" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title class="title-medium">
          <mat-icon class="material-symbols-outlined stepIcon">person_search</mat-icon>
          {{ 'onlineIdentification.people.title' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p class="body-medium">{{ 'onlineIdentification.people.description' | translate }}</p>
      @for (selection of selections; track selection.id) {
        <app-user-selection
          [caseId]="case.identification"
          (userSelected)="userSelected(selection, $event)"
          (userDeselected)="userDeselected(selection)"
          (newUserChange)="selection.editing = $event"
          (creatingUserChange)="selection.creating = $event"/>
        @if (selection.started || selection.failed) {
          <output aria-live="polite" class="body-medium">
            {{ (selection.started ? 'onlineIdentification.people.started' : 'onlineIdentification.people.failed') | translate }}
          </output>
        }
      }
    </mat-expansion-panel>
  </div>
  <div id="actionsContainer" class="flexRowContainer inputContainer">
    <button mat-flat-button [disabled]="!canStart"
            (click)="startOnlineIdentification()">
      {{ 'onlineIdentification.actions.start' | translate }}
    </button>
  </div>
</div>
